/** Service Desk console: Contacts list, profile drawer and the approve-joiner dialog (C05, SD-S1-46). */
export const serviceContact = {
  subtitle: "The people behind every ticket and order: who they are, how they were verified, and what they may order.",
  actions: { import: "Import contacts" },
  filters: {
    group: "Contact filters",
    search: "Search name or e-mail…",
    searchLabel: "Search contacts",
    organisation: "Organisation",
    allOrganisations: "All organisations",
    all: "All",
    pending: "Pending",
    admins: "Org admins",
    unlinked: "No organisation",
    blocked: "Blocked",
    clear: "Clear filters",
  },
  banner: {
    pending_one: "{{count}} joiner is waiting for approval.",
    pending_other: "{{count}} joiners are waiting for approval.",
    signedIn: "{{name}} signed in with the domain {{domain}}.",
    show: "Show pending",
  },
  table: {
    label: "Contacts",
    name: "Name",
    organisation: "Organisation",
    role: "Org role",
    verified: "Verified",
    ordering: "Ordering",
    language: "Language",
    noOrganisation: "No organisation",
    approver: "Approver",
    cannotOrder: "Cannot order",
    limit: "{{amount}} limit",
    noLimit: "No limit",
    showing: "Showing {{shown}} of {{total}} contacts",
    loadMore: "Load more",
  },
  role: { org_admin: "Organisation admin", member: "Member" },
  status: { pending_approval: "Pending approval", blocked: "Blocked", archived: "Archived" },
  language: { en: "English", fil: "Filipino" },
  visibility: { own: "Their own tickets", organisation: "All organisation tickets" },
  empty: {
    title: "No contacts yet",
    body: "People appear here when they raise a request, verify their e-mail or are imported from a spreadsheet.",
    filteredTitle: "No contacts match",
    filteredBody: "Try another filter or search.",
  },
  error: { title: "We couldn't load contacts", body: "Something went wrong on our side. Please try again." },
  drawer: {
    loading: "Loading contact",
    notFoundTitle: "Contact not found",
    notFoundBody: "It may have been removed, or the link is wrong.",
    errorTitle: "We couldn't load this contact",
    pendingTitle: "Waiting for approval.",
    pendingBody: "Joined with the domain {{domain}} and verified the e-mail with a code. They see nothing until you approve.",
    pendingBodyNoDomain: "Asked to join this organisation. They see nothing until you approve.",
    review: "Review",
    blockedBanner: "This contact is blocked. New requests from them are refused.",
    archivedBanner: "This contact is archived.",
    profile: "Profile",
    email: "E-mail",
    mobile: "Mobile",
    organisation: "Organisation",
    jobTitle: "Job title",
    language: "Language",
    verifiedVia: "Verified via",
    verifiedAt: "Verified on",
    notVerified: "Not verified yet",
    added: "Added",
    rights: "Role and ordering rights",
    rightsNoOrdering: "Role and access",
    orgRole: "Organisation role",
    orgRoleAdmin: "Organisation admin (sees all organisation tickets)",
    orgRoleMember: "Member",
    visibilityAdmin: "Organisation admins always see all organisation tickets.",
    visibility: "Can see",
    mayOrder: "May place orders",
    mayOrderHint: "In chat, the web app and Messenger",
    limit: "Order limit (₱, incl. VAT)",
    saveLimit: "Save limit",
    approver: "Can approve orders",
    approverHint: "Receives approval requests from colleagues over their limit",
    readOnly: "You can view this contact but not change it.",
    consent: "Consent and privacy (RA 10173)",
    consentGiven: "Consent recorded",
    consentNotice: "Notice version {{version}}",
    consentNone: "No consent recorded yet.",
    tickets: "Tickets",
    ticketsCount: "Tickets ({{count}})",
    noTickets: "No tickets.",
    noTicketAccess: "You need ticket access to see this person's tickets.",
    ticketsError: "We couldn't load this person's tickets.",
    verify: "Mark verified (phone call)",
    verifyHint: "Confirm you checked this person's identity by phone. It is logged with your name.",
    verifyConfirmTitle: "Mark {{name}} as verified?",
    verifyConfirmBody: "Do this only after you confirmed who they are by phone. Their tickets will show a verified requester.",
    verifyConfirm: "Mark verified",
    verified: "{{name}} marked as verified",
    roleSaved: "Organisation role updated",
    visibilitySaved: "Visibility updated",
    orderingSaved: "Ordering rights updated",
    limitSaved: "Order limit saved",
    block: "Block contact",
    blockHint: "A blocked contact cannot open new requests. Their history stays.",
    blockConfirmTitle: "Block {{name}}?",
    blockConfirmBody: "New requests from them are refused until you unblock them. Existing tickets are not changed.",
    blockConfirm: "Block contact",
    blocked: "{{name}} blocked",
    unblock: "Unblock",
    unblockHint: "Unblocking lets this contact raise requests again.",
    unblocked: "{{name}} unblocked",
  },
  validation: { limit: "Enter a whole number of pesos, at least 1." },
  approve: {
    title: "Approve joiner",
    why: "Joined by domain {{domain}} (pending approval) and verified the e-mail with a code. They see nothing until you approve.",
    whyNoDomain: "Asked to join this organisation. They see nothing until you approve.",
    role: "Organisation role",
    visibility: "Can see",
    mayOrder: "May place orders in chat",
    limit: "Order limit (₱, incl. VAT)",
    decline: "Decline",
    cancel: "Cancel",
    confirm: "Approve",
    approved: "{{name}} approved",
    approvedAdmin: "{{name}} approved as an organisation admin",
    declined: "{{name}} declined",
    declineTitle: "Decline {{name}}?",
    declineBody: "They are not added to the organisation and stay a normal contact. They can ask an organisation admin for an invitation.",
    declineConfirm: "Decline",
  },
} as const;
